<template>
  <div id="home" class="">
    <Loading :loading="submitLoading" style="z-index: 9999" />
    <div style="background-color: white; margin: 10px 20px; display: flex">
      <div class="content-left" style="width: auto">
        <el-menu
          default-active="2"
          class="el-menu-vertical-demo"
          text-color="#000000"
        >
          <el-menu-item index="2" @click="MenuSelect">
            <i class="el-icon-setting"></i>
            <template #title>FX-酒店集团映射</template>
          </el-menu-item>
          <el-menu-item index="3" @click="MenuSelect">
            <i class="el-icon-setting"></i>
            <template #title>HBE酒店集团</template>
          </el-menu-item>
          <el-menu-item index="4" @click="MenuSelect">
            <i class="el-icon-setting"></i>
            <template #title>HBE酒店打分</template>
          </el-menu-item>
          <el-menu-item index="1" @click="MenuSelect">
            <i class="el-icon-setting"></i>
            <template #title>渠道</template>
          </el-menu-item>
          <el-menu-item index="6" @click="MenuSelect">
            <i class="el-icon-setting"></i>
            <template #title>酒店积分</template>
          </el-menu-item>
        </el-menu>
      </div>
      <div
        class="pos_container_panel"
        style="padding-left: 2rem; width: 90%"
        v-show="this.isShow == '1'"
      >
        <el-form
          :inline="true"
          class="demo-form-inline"
          style="margin-left: 6rem; padding-top: 2rem"
        >
          <el-row>
            <el-col :span="24" style="float: right">
              <div class="grid-content bg-purple-light" style="float: right">
                <el-button
                  type="warning"
                  class="harpIDbtn"
                  style="margin-left: 3rem"
                  @click="customSearch()"
                >
                  搜索
                </el-button>
                <el-button
                  type="warning"
                  class="harpIDbtn"
                  style="margin-left: 3rem"
                  @click="addSoruce()"
                >
                  新增
                </el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
        <el-table
          :data="tableData"
          border
          style="width: 90%; margin-top: 50px; margin-left: 100px"
        >
          <el-table-column
            prop="name"
            label="渠道名称"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="isPointEligible"
            label="是否可积分"
            align="center"
            :formatter="StatusFormat"
          ></el-table-column>
          <el-table-column
            prop="createdDate"
            label="创建时间"
            align="center"
            :formatter="FormatDateTime"
          ></el-table-column>
          <el-table-column
            prop="updateDate"
            label="最后一次修改时间"
            align="center"
            :formatter="FormatDateTime"
          >
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template #default="scope">
              <!-- <el-button
                @click="handleSetting(scope.row)"
                type="text"
                size="small"
                >配置映射</el-button
              > -->
              <el-button
                @click="handleChange(scope.row)"
                type="text"
                size="small"
                >修改</el-button
              >
              <!-- <el-button
                type="text"
                v-if="scope.row.status == 0"
                size="small"
                @click.native.prevent="statusRow(scope.row)"
                >启用
              </el-button>
              <el-button
                type="text"
                v-if="scope.row.status == 1"
                size="small"
                @click.native.prevent="statusRow(scope.row)"
                >禁用
              </el-button> -->
              <el-button
                type="text"
                size="small"
                @click.prevent="deleteRow(scope.row)"
                >删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-dialog title="新增" v-model="dialogFormVisible" @close="closeaddDialog('form')">
          <div v-draggable>
            <el-form :model="form" ref="form">
              <el-form-item
                prop="name"
                label="渠道名称:"
                :label-width="formLabelWidth"
                :rules="[
                  {
                    required: true,
                    message: '请输入渠道名称',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input v-model="form.name" autocomplete="off" style="width: 58%"></el-input>
              </el-form-item>
              <el-form-item
                label="是否可积分:"
                :label-width="formLabelWidth"
                prop="isPointEligible"
                :rules="[
                  {
                    required: true,
                    message: '请选择是否可积分',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-radio-group v-model="form.isPointEligible">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </div>
          <template #footer>
            <div class="dialog-footer">
              <el-button type="primary" @click="dataSave()">保存</el-button>
              <el-button @click="cancel()">取 消</el-button>
            </div>
          </template>
        </el-dialog>
        <el-dialog title="修改" v-model="changeSourceFlag">
          <div v-draggable>
            <el-form :model="changeForm">
              <el-form-item
                label="渠道名称:"
                :label-width="formLabelWidth"
                prop="name"
                :rules="[
                  {
                    required: true,
                    message: '请输入渠道名称',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input v-model="changeForm.name" autocomplete="off" style="width: 58%"></el-input>
              </el-form-item>
              <el-form-item
                label="是否可积分:"
                :label-width="formLabelWidth"
                prop="isPointEligible"
                :rules="[
                  {
                    required: true,
                    message: '请选择是否可积分',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-radio-group v-model="changeForm.isPointEligible">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </div>
          <template #footer>
            <div class="dialog-footer">
              <el-button type="primary" @click="changeSave()">保存</el-button>
              <el-button @click="cancel()">取 消</el-button>
            </div>
          </template>
        </el-dialog>
        <el-dialog title="" v-model="deletedialogVisible" width="30%">
          <div v-draggable>
            <span>请确认是否删除</span>
          </div>
          <template #footer>
            <span class="dialog-footer">
              <el-button type="primary" @click="confirmDelete">确 定</el-button>
              <el-button @click="cancelDelete">取 消</el-button>
            </span>
          </template>
        </el-dialog>
        <el-dialog title="" v-model="statusdialogVisible" width="30%">
          <div v-draggable>
            <span>请确认是否更改当前状态</span>
          </div>
          <template #footer>
            <span class="dialog-footer">
              <el-button type="primary" @click="confirmStatus">确 定</el-button>
              <el-button @click="statusdialogVisible = false">取 消</el-button>
            </span>
          </template>
        </el-dialog>
        <el-dialog title="配置酒店集团" v-model="settingSourceFlag" :close-on-click-modal="false">
          <div v-draggable>
            <el-tag
              :key="tag.id"
              v-for="tag in dynamicTags"
              closable
              :disable-transitions="false"
              @close="handleClose(tag)"
              style="margin: 0px 10px 5px 0px"
            >
              {{ tag.groupCName }}
            </el-tag>
            <el-input
              class="input-new-tag"
              v-if="inputVisible"
              v-model="inputValue"
              ref="saveTagInput"
              size="small"
              style="width: 120px"
              @keyup.enter="handleInputConfirm"
              @blur="handleInputConfirm"
            ></el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInput">+ New Tag</el-button>
          </div>
        </el-dialog>
      </div>
      <HBEGroup v-show="this.isShow == '2'"></HBEGroup>
      <HBEGroupMapping v-show="this.isShow == '3'"></HBEGroupMapping>
      <HBEHotelScore v-show="this.isShow == '4'"></HBEHotelScore>
      <HBEShopping v-show="this.isShow == '5'"></HBEShopping>
      <HBEPoints v-show="this.isShow == '6'"></HBEPoints>
      <ConfirmBoxs
        :centerDialogVisible="confirmFlag"
        :confirmMsg="confirmMsg"
        :icon="confirmIcon"
        @setConfirmFlag="setConfirmFlag"
      ></ConfirmBoxs>
    </div>
  </div>
</template>

<script>
import HBEGroup from "@/views/HBEConfig/HBEHotelGroupConfig/HBEGroup";
import HBEGroupMapping from "@/views/HBEConfig/HBEHotelGroupConfig/HBEGroupMapping";
import HBEHotelScore from "@/views/HBEConfig/HBEHotelGroupConfig/HBEHotelScore";
import HBEShopping from "@/views/HBEConfig/HBEHotelGroupConfig/HBEShopping";
import HBEPoints from "@/views/HBEConfig/HBEHotelGroupConfig/HBEPoints";
import {
  sourceList,
  sourceDelete,
  sourceSave,
  sourceStatus,
  sourceGroupList,
  deleteSourceGroup,
  addSourceGroup,
} from "@/api/shoppingData";
import ConfirmBoxs from "@/components/confirmBoxs.vue";
import Loading from "@/components/Loading.vue";
import { formatDateTime } from "../../utils/utils.js";

export default {
  name: "HBESource",
  components: {
    ConfirmBoxs,
    HBEGroup,
    Loading,
    HBEGroupMapping,
    HBEHotelScore,
    HBEShopping,
    HBEPoints,
  },
  data() {
    return {
      deletedialogVisible: false,
      deleteFlag: false,
      deleteparams: {},
      statusdialogVisible: false,
      statusparams: {},
      confirmFlag: false,
      changeRow: {},
      form: {
        name: "",
        isPointEligible: false,
      },
      changeForm: {
        id: 0,
        name: "",
        isPointEligible: false,
      },
      //新增dialog
      confirmIcon: "",
      confirmMsg: "",
      dialogFormVisible: false,
      changeSourceFlag: false,
      formLabelWidth: "150px",
      tableData: [],
      isShow: "2",
      settingSourceFlag: false,
      settingRow: {},
      dynamicTags: [],
      inputVisible: false,
      inputValue: "",
      submitLoading: false,
    };
  },
  mounted() {
    this.customSearch();
  },
  methods: {
    closeaddDialog(formRule) {
      console.log(formRule);
      this.$refs[formRule].resetFields();
    },

    addSoruce() {
      this.dialogFormVisible = true;
    },
    //新增保存
    async dataSave() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let saveParams = {
            Name: this.form.name,
            isPointEligible: this.form.isPointEligible,
          };
          console.log(saveParams, "saveParams");
          sourceSave(saveParams)
            .then((res) => {
              if (res.code == 200) {
                if (res.data.error.code == 0) {
                  this.confirmFlag = true;
                  this.deleteFlag = false;
                  this.confirmMsg = "新增成功";
                  this.dialogFormVisible = false;
                  this.customSearch();
                  this.currentPage1 = 1;
                  this.form = {};
                } else {
                  this.confirmFlag = true;
                  this.deleteFlag = false;
                  this.confirmMsg = res.data.error.message; //res.message
                  this.currentPage1 = 1;
                }
              } else {
                this.confirmFlag = true;
                this.deleteFlag = false;
                this.confirmMsg = res.message; //res.message
                this.currentPage1 = 1;
              }
            })
            .catch(function (error) {
              console.log("新增失败", error.objError);
              this.customSearch();
            });

          // this.form = {};
        }
      });
    },
    // 修改保存
    async changeSave() {
      let saveParams = {
        id: this.changeForm.id,
        name: this.changeForm.name,
        isPointEligible: this.changeForm.isPointEligible,
      };
      await sourceSave(saveParams)
        .then((res) => {
          if (res.code == 200) {
            if (res.data.error.code == 0) {
              this.confirmFlag = true;
              this.deleteFlag = false;
              this.confirmMsg = "修改成功";
              this.currentPage1 = 1;
              this.changeSourceFlag = false;
              this.customSearch();
            } else {
              this.confirmFlag = true;
              this.deleteFlag = false;
              this.confirmMsg = res.data.error.message;
            }
          } else {
            this.confirmFlag = true;
            this.deleteFlag = false;
            this.confirmMsg = res.message;
          }
        })
        .catch(function (error) {
          console.log("修改失败", error.objError);
        });
    },
    //修改button
    handleChange(row) {
      console.log(row);
      this.changeRow = row;
      this.changeSourceFlag = true;
      this.changeForm.id = this.changeRow.id;
      this.changeForm.name = this.changeRow.name;
      this.changeForm.isPointEligible = this.changeRow.isPointEligible;
    },
    //取消button
    cancel() {
      this.dialogFormVisible = false;
      this.changeSourceFlag = false;
      this.form.name = "";
    },
    //删除dialog
    cancelDelete() {
      this.deletedialogVisible = false;
    },
    //删除
    deleteRow(row) {
      this.deletedialogVisible = true;
      this.deleteparams = {
        params: {
          id: row.id,
        },
      };
    },
    //更改状态
    statusRow(row) {
      this.statusdialogVisible = true;
      this.statusparams = {
        params: {
          id: row.id,
        },
      };
    },
    async confirmDelete() {
      this.deletedialogVisible = false;
      sourceDelete(this.deleteparams)
        .then((res) => {
          if (res.code == 200) {
            this.confirmFlag = true;
            this.confirmMsg = "删除成功";
            this.customSearch();
            this.currentPage1 = 1;
          } else {
            this.confirmFlag = true;
            this.confirmMsg = "删除失败";
          }
        })
        .catch(() => {
          console.log("删除请求失败");
        });
    },
    async confirmStatus() {
      this.statusdialogVisible = false;
      sourceStatus(this.statusparams)
        .then((res) => {
          if (res.code == 200) {
            this.confirmFlag = true;
            this.confirmMsg = "更改状态成功";
            this.customSearch();
            this.currentPage1 = 1;
          } else {
            this.confirmFlag = true;
            this.confirmMsg = "更改状态失败";
          }
        })
        .catch(() => {
          console.log("更改状态请求失败");
        });
    },
    setConfirmFlag(value) {
      this.confirmFlag = value;
    },
    //搜索button
    async customSearch(int) {
      let searchparams = {
        params: {
          page: int ? int : 1,
          pageSize: 200,
        },
      };
      await sourceList(searchparams)
        .then((res) => {
          console.log(res);
          this.tableData = res.data.list;
        })
        .catch(function (error) {
          console.log("请求失败", error.objError);
        });
    },
    //菜单选择
    MenuSelect(value) {
      let index = value.index;
      this.isShow = index;
    },
    StatusFormat(value) {
      if (value.isPointEligible == 1) {
        return "可积分";
      } else {
        return "不可积分";
      }
    },
    FormatDateTime(value, index) {
      if (index.property == "createdDate") {
        return formatDateTime(value.createdDate, "YYYY-MM-DD HH:mm:ss");
      } else {
        return formatDateTime(value.updateDate, "YYYY-MM-DD HH:mm:ss");
      }
    },
    //配置button
    handleSetting(row) {
      this.settingRow = row;
      this.getSourceGroup();
      this.settingSourceFlag = true;
    },
    //配置映射
    async getSourceGroup() {
      this.submitLoading = true;
      let searchparams = {
        params: {
          sourceId: this.settingRow.id,
        },
      };
      await sourceGroupList(searchparams)
        .then((res) => {
          console.log(res);
          this.submitLoading = false;
          this.dynamicTags = res.data;
        })
        .catch(function (error) {
          this.submitLoading = false;
          console.log("请求失败", error.objError);
        });
    },
    //删除
    async handleClose(tag) {
      // this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      this.submitLoading = true;
      let searchparams = {
        params: {
          id: tag.id,
        },
      };
      await deleteSourceGroup(searchparams)
        .then((res) => {
          this.submitLoading = false;
          if (res.code == 200 && res.data > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.dynamicTags[i].id === tag.id) {
                this.dynamicTags.splice(i, 1);
              }
            }
          } else {
            this.confirmFlag = true;
            this.confirmMsg = "删除失败请重新删除";
          }
        })
        .catch(function (error) {
          this.submitLoading = false;
          console.log("请求失败", error.objError);
        });
    },
    //添加
    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    //添加完成
    async handleInputConfirm() {
      this.submitLoading = true;
      let inputValue = this.inputValue;
      if (inputValue == "") {
        this.confirmFlag = true;
        this.confirmMsg = "请输入正确的酒店code";
        this.submitLoading = false;
        return;
      }
      let searchparams = {
        params: {
          sourceId: this.settingRow.id,
          code: inputValue,
        },
      };
      await addSourceGroup(searchparams)
        .then((res) => {
          this.submitLoading = false;
          if (res.code == 200 && res.data > 0) {
            this.getSourceGroup();
          } else {
            this.confirmFlag = true;
            this.confirmMsg = res.message;
          }
        })
        .catch(function (error) {
          this.submitLoading = false;
          this.confirmFlag = true;
          this.confirmMsg = "添加失败请重新添加";
          console.log("请求失败", error.objError);
        });

      this.inputVisible = false;
      this.inputValue = "";
    },
  },
};
</script>

<style scoped>
.paginationsty {
  float: right;
  margin: 1rem 0;
}

.pos_container_panel {
  padding: 0 16rem 4rem;
}

.harpIDbtn {
  width: 10rem;
  height: 3rem;
  padding: 0 !important;
  font-size: 1rem !important;
}
</style>
